<!-- Modal Wrapper - Prevents backdrop clicks from closing modal -->
<div class="me-sic-assignment-modal-wrapper" (click)="$event.stopPropagation()">
  <!-- Modal Header -->
  <div class="modal-header">
    <h3 class="modal-title">{{modalTitle}}</h3>
    <div class="header-actions">
      <i class="fa"  
         [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"  
         style="margin-right: 10px; cursor: pointer;"  
         (click)="minimise=!minimise"></i>
      <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
    </div>
  </div>

  <!-- Modal Body -->
  <div class="modal-body no-modal-body-scroll" [hidden]="minimise">
    @if (showFormLoader) {
<div class="formLoader">
      <i class="fa fa-spinner fa-spin gt-refresh"></i>
    </div>
}

    @if (!showFormLoader) {
<div class="panel panel-default">
      <div class="panel-body">
        <div class="row">
          <div class="col-md-4">
            <label><b>Tax Year</b></label>
          </div>
          <div class="col-md-4">
            <label><b>Parent ME</b></label>
          </div>
          @if (sicCodeData.length > 0) {
<div class="col-md-4">
            <label><b>SIC Code</b></label>
          </div>
}
        </div>
        <div class="row">
          <div class="col-md-4">
            <strong>{{selectedTaxYear}}</strong>
          </div>
          <div class="col-md-4">
            <select id="FTC_MESIC_CRUD_2" 
                    class="form-control" 
                    [(ngModel)]="selectedMEKey"
                    (ngModelChange)="filterParentMeSelection()"
                    [disabled]="!showParentMeDropdown">
              <option [ngValue]="null">SELECT</option>
              @for (bsla of bslaCodeData; track $index) {
<option 
                      [ngValue]="bsla.PARENT_ME_KEY">
                {{bsla.PARENT_ME_NAME}}
              </option>
}
            </select>
          </div>
          @if (sicCodeData.length > 0) {
<div class="col-md-4">
            <!-- Searchable Multiselect for SIC Codes -->
            <div class="searchable-multiselect-container">
              <div class="custom-searchable-multiselect" 
                   [class.open]="sicCodeDropdownOpen"
                   dstClickOutside
                   (clickOutside)="closeSicCodeDropdown()">
                <div class="dropdown-input-wrapper" 
                     (click)="toggleSicCodeDropdown()">
                  <input type="text" 
                         class="form-control dropdown-input" 
                         [value]="getSelectedSicCodesDisplay()"
                         readonly
                         placeholder="Select SIC Codes"
                         [disabled]="!showOptionSicCodeSelect">
                  <i class="fa fa-chevron-down dropdown-arrow" 
                     [ngClass]="{'fa-chevron-up': sicCodeDropdownOpen, 'fa-chevron-down': !sicCodeDropdownOpen}"></i>
                </div>
                @if (sicCodeDropdownOpen && showOptionSicCodeSelect) {
<div class="dropdown-menu" 
                    
                     (click)="$event.stopPropagation()">
                  <div class="dropdown-search-wrapper">
                    <input type="text" 
                           class="form-control dropdown-search-input" 
                           [(ngModel)]="sicCodeSearchText"
                           (ngModelChange)="onSicCodeSearchChange()"
                           placeholder="Search SIC codes..."
                           (click)="$event.stopPropagation()">
                    <i class="fa fa-search dropdown-search-icon"></i>
                  </div>
                  <div class="dropdown-actions">
                    <button type="button" 
                            class="btn btn-link btn-sm select-all-btn"
                            (click)="selectAllSicCodes(); $event.stopPropagation()">
                      Select All
                    </button>
                    <button type="button" 
                            class="btn btn-link btn-sm unselect-all-btn"
                            (click)="unselectAllSicCodes(); $event.stopPropagation()">
                      Unselect All
                    </button>
                  </div>
                  <div class="dropdown-items-wrapper">
                    @if (sicCodeFilteredData.length === 0) {
<div 
                         class="dropdown-no-results">
                      No results found
                    </div>
}
                    @for (sicCode of sicCodeFilteredData; track $index) {
<div 
                         class="dropdown-item checkbox-item"
                         (click)="!isCheckboxClick($event) && toggleSicCodeSelection(sicCode); $event.stopPropagation()">
                      <input type="checkbox" 
                             [checked]="isSicCodeSelected(sicCode)"
                             (change)="toggleSicCodeSelection(sicCode); $event.stopPropagation()"
                             (click)="$event.stopPropagation()">
                      <label (click)="toggleSicCodeSelection(sicCode); $event.stopPropagation()">
                        {{sicCode.SIC_CODE_DESC || sicCode.CODE_DISP_DESC}}
                      </label>
                    </div>
}
                  </div>
                </div>
}
              </div>
            </div>
          </div>
}
        </div>
      </div>
    </div>
}
  </div>

  <!-- Modal Footer -->
  <div class="modal-footer" [hidden]="minimise">
    @if (showOptionSicCodeSelect) {
<div class="footer-buttons">
      <button class="save-button" 
              type="button" 
              (click)="save()" 
              [disabled]="isSaveClicked || crudLoading"> 
        @if (isSaveClicked || crudLoading) {
<span>
          <i class="fa fa-spinner fa-pulse"></i>
        </span>
}
        Save
      </button>
      <button class="reset-button" 
              type="button" 
              (click)="reset()"
              [disabled]="crudLoading">
        Reset
      </button>
      <button class="cancel-button" 
              type="button" 
              (click)="cancel()"
              [disabled]="crudLoading">
        Cancel
      </button>
    </div>
}
    @if (!showOptionSicCodeSelect) {
<div class="footer-buttons">
      <button class="reset-button" 
              type="button" 
              (click)="reset()"
              [disabled]="crudLoading">
        Reset
      </button>
      <button class="cancel-button" 
              type="button" 
              (click)="cancel()"
              [disabled]="crudLoading">
        Cancel
      </button>
    </div>
}
  </div>
</div>
<!-- End Modal Wrapper -->
